import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})
export class NotesComponent implements OnInit {

  upperDiv: Array<ClassEntry>;

  constructor() {
    this.upperDiv = [];
  }

  ngOnInit() {
    this.upperDiv = [
      {
        title: "CS 180 (W18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqkhKGlugDGE60Lauk"
        },
        password: "y9W7XhDycw4k"
      },
      {
        title: "CS 151B (W18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqkhKGlugDGE60Lauk"
        },
        password: "cpZwI9gBv98n"
      },
      {
        title: "ENGR 111 (W18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqkhKGlugDGE60Lauk"
        },
        password: "N1zAWi&5eHdN"
      },
      {
        title: "CS 131 (S18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqlF6L9rMv5aW_XwVH"
        },
        password: "gc43ciTG!i$V"
      },
      {
        title: "CS 161 (F18)",
        body: {
          Github: ".",
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqlxQpX7xhKwQL17oQ",
        },
        password: "X3fPHyI8j&Rs"
      },
      {
        title: "CS 181 (F18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqlxQpX7xhKwQL17oQ"
        },
        password: "gFeozdqy63!a"
      },
      {
        title: "CS 144 (F18)",
        body: {
          Notes: "https://1drv.ms/u/s!AkfMFZT7uYqqlxQpX7xhKwQL17oQ",
          "Cheat Sheet": ".",
        },
        password: "AA$65Yom8u!!"
      },
    ]
  }
}

class ClassEntry {
  title: string;
  body: {};
  password: string;
}